// @flow
import React from 'react';
import { isEmpty } from 'lodash';

import { ContentSlideShow } from 'Components/frameworks/content-slideshow/ContentSlideShow.jsx';
import Image from 'Components/frameworks/image/Image.jsx';

export type AwardProps = {
  altMsg?: string,
  imageUrl: string,
};

type TripAdvisorAwardsProps = {
  awards: Array<AwardProps>,
  className?: string,
};

export function TripAdvisorAwards(props: TripAdvisorAwardsProps) {
  const { awards = [], className } = props;

  if (isEmpty(awards)) return null;

  return (
    <section className={className}>
      <ContentSlideShow>
        {awards.map(({ altMsg, imageUrl }) => {
          return imageUrl ? (
            <article className="leading-none overflow-hidden px-1 text-center" key={imageUrl}>
              <Image
                altMsg={altMsg}
                className="mx-auto"
                dontChangeAnything
                imageUrl={imageUrl}
                style={{ maxHeight: 'calc(140rem / 16)' }}
              />
            </article>
          ) : null;
        })}
      </ContentSlideShow>
    </section>
  );
}
